import { request } from '@/apis/request';
import httpApi from '@/apis/httpApi';
import {
  GetCommunityListProps,
  post_categoryProps,
  listProps,
  Banner_listProps,
  getPostCategoryProps,
  findAllGameListByRandProps,
  gameListProps,
  pcGameListByRandProps
} from './typings';
import { GetUserPostData } from '@/views/user/personal/service';
const {
  getCommunityList,
  pcCommunityHome,
  getBannerList,
  getPostByCategory,
  publishPost,
  getPostCategory,
  getCredit,
  modifyPost,
  recommend,
  searchPosts,
  postRecommend,
  postSearchPosts,
  saveDraft,
  draftList,
  deleteDraft,
  pcGameList,
  keywordExpansion
} = httpApi.commonity;
const { byRand } = httpApi.home;
const { getGamesInfo } = httpApi.game;
// 社区列表
export interface GetCommunityListParams {
  is_all: number;
  select_id?: string;
}

export function apiGetCommunityList(params?: GetCommunityListParams) {
  return request<GetCommunityListProps>({
    method: 'GET',
    url: getCommunityList,
    params
  });
}

// 获取社区子模块和分类
interface PcCommunityHomeParams {
  community_id?: string;
}
export interface PcCommunityHomeProps {
  community?: listProps;
  post_category: post_categoryProps[];
}
export function apiPcCommunityHome(params?: PcCommunityHomeParams) {
  return request<PcCommunityHomeProps>({
    method: 'GET',
    url: pcCommunityHome,
    params
  });
}

// Banner列表
export function apiGetBannerList() {
  return request<Banner_listProps[]>({
    method: 'GET',
    url: getBannerList
  });
}

// 获取栏目帖子列表、置顶帖子
export interface getPostByCategoryParams {
  cate_id?: string;
  community_id?: string;
  sort_type?: number;
  next_page?: number;
  c_version?: number;
}
export function apiGetPostByCategory(params: getPostByCategoryParams) {
  return request<GetUserPostData>({
    method: 'GET',
    url: getPostByCategory,
    params
  });
}
// 发布帖子
export interface publishPostParams {
  content: string;
  title: string;
  topic?: number;
  community_id: number | string;
  simple_content: string;
  game_id: number | string;
  draft_id: number | string;
  commodity_id: string;
}
export interface publishPostProps {
  is_first: boolean;
}
export function apiPublishPost(data: publishPostParams) {
  return request<GetUserPostData>({
    method: 'POST',
    url: publishPost,
    data
  });
}

// 编辑帖子
interface ModifyPostParams {
  post_id?: number;
  content: string;
  title: string;
  topic?: number;
  simple_content: string;
  game_id: number | string;
  draft_id: number | string;
  commodity_id: string;
}
export function apiModifyPost(data: ModifyPostParams) {
  return request({
    method: 'POST',
    url: modifyPost,
    data
  });
}

// 获取发帖选择栏目
export function apiGetPostCategory(params: PcCommunityHomeParams) {
  return request<post_categoryProps[]>({
    method: 'GET',
    url: getPostCategory,
    params
  });
}

// 获取游戏信息
export interface findAllGameListByRandParams {
  limit: number;
}
export function apiFindAllGameListByRand(data: findAllGameListByRandParams) {
  return request<findAllGameListByRandProps>({
    method: 'POST',
    url: byRand,
    data
  });
}
// 获取游戏信息(不包含纯PC游戏)
export interface pcGameListByRandParams {
  limit: number;
}

export function apiPcGameList(data: pcGameListByRandParams) {
  return request<pcGameListByRandProps>({
    method: 'GET',
    url: pcGameList,
    data
  });
}

// 批量获取游戏信息
interface getGamesInfoParams {
  ids: number;
}
interface getGamesInfoProps {
  list: gameListProps[];
}
export function apiGetGamesInfo(data: getGamesInfoParams) {
  return request<getGamesInfoProps>({
    method: 'POST',
    url: getGamesInfo,
    data
  });
}

// 用户信用分
export interface getCreditProps {
  credit?: number;
  publish_credit?: number;
  comment_credit?: number;
}
export function apiGetCredit() {
  return request<getCreditProps>({
    method: 'POST',
    url: getCredit
  });
}

// 搜索推荐帖子列表
export interface PostRecommendJson {
  token: string;
}

export function recommends() {
  return request<getPostCategoryProps[]>({
    method: 'GET',
    url: recommend
  });
}

// 社区模块搜索帖子
export interface SearchPostsJson {
  search_keyword: string;
}

export function searchPost(params?: SearchPostsJson) {
  return request<getPostCategoryProps[]>({
    method: 'GET',
    url: searchPosts,
    params
  });
}

// 社区模块搜索帖子
export interface KeywordExpansionJson {
  search_keyword: string;
  search_type: number;
}

export function apiKeywordExpansion(params: KeywordExpansionJson) {
  return request<getPostCategoryProps[]>({
    method: 'GET',
    url: keywordExpansion,
    params
  });
}

// 社区模块推荐列表

export function apiPostRecommend() {
  return request<getPostCategoryProps[]>({
    method: 'GET',
    url: postRecommend
  });
}

// 编辑器专用搜索推荐帖子列表

export interface PostSearchPostsJson {
  // token: string;
  search_keyword: string;
}

export function postSearchPost(params?: PostSearchPostsJson) {
  return request<getPostCategoryProps[]>({
    method: 'GET',
    url: postSearchPosts,
    params
  });
}

// 草稿箱列表
export function draftLists() {
  return request<getPostCategoryProps[]>({
    method: 'GET',
    url: draftList
  });
}

// 保存草稿
export interface SaveDraftJson {
  title: string;
  content: string;
  draft_id?: any;
  topic?: any;
  content_txt?: any;
  commodity_id: string;
  game_id?: number | string;
  circle_id?: number | string;
}

/** 修改帖子保存草稿：从帖子详情取 game_id、circle_id */
export function resolvePostDetailDraftIds(
  detail?: {
    game_id?: number | string | null;
    circle_id?: number | string | null;
    circle?: { id?: number | string | null } | null;
  } | null
): Pick<SaveDraftJson, 'game_id' | 'circle_id'> {
  if (!detail) return {};
  const params: Pick<SaveDraftJson, 'game_id' | 'circle_id'> = {};
  if (detail.game_id != null && detail.game_id !== '') {
    params.game_id = detail.game_id;
  }
  const circleId = detail.circle_id ?? detail.circle?.id;
  if (circleId != null && circleId !== '') {
    params.circle_id = circleId;
  }
  return params;
}

export function saveDrafts(data?: SaveDraftJson) {
  return request<getPostCategoryProps[]>({
    method: 'POST',
    url: saveDraft,
    data
  });
}

// 删除草稿
export interface DeleteDraftJson {
  draft_id: number;
}

export function deleteDrafts(data?: DeleteDraftJson) {
  return request<getPostCategoryProps[]>({
    method: 'POST',
    url: deleteDraft,
    data
  });
}

// 帖子事件打点上报
export interface PostCollectJson {
  created_at: string;
  device: string;
  appv: string;
  series: string;
  user_id: number;
  post_id: number;
  stay_time: number;
}

export function postCollect(data?: DeleteDraftJson) {
  return request<getPostCategoryProps[]>({
    method: 'POST',
    url: httpApi.collection.postColletApi,
    data
  });
}
